export default `I graduated from University of Florida with a 
Bachelor of Science in Computer Science. I moved to the United States in 2016 after 
pursuing both a French & Lebanese Baccalaureate in Lebanon and completed my Associate’s 
Degree in St Augustine, Florida. I am fluent in English, French and Arabic.
I will be joining Meta this year as a Software Engineer.`;
